<template>
  <div class="ctrl-article-category">
    <!-- aaa<CtrlCtrlHome /> -->
  <router-view :categoryId="categoryId"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import CtrlCtrlHome from "@/components/Ctrl/Home.vue";
export default {
  name: "CtrlArticleCategory",
  components: {
    // CtrlCtrlHome,
  },
  props: { 
    categoryId: String
     },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>